export enum SortDirectionEnum {
  EMPTY,
  ASC,
  DESC,
}
